export const tableHeaders = ["Full Name", "Email", "Role"];
